.rowSortable {
  &[data-dragging='true'] {
    opacity: 0.4;
  }

  // Drop target — primary subtle tint across the whole row.
  &[data-drop-target='true'] {
    background: var(--bs-primary-bg-subtle);
  }

  // Accent line direction is driven by which half of the row the cursor
  // is over. `data-drop-side="before"` (top half) renders a top-edge line
  // ("insert above"); `data-drop-side="after"` (bottom half) renders a
  // bottom-edge line ("insert below"). Applied via inset box-shadow on
  // every `<td>` (rather than `<tr>`) because Bootstrap tables use
  // `border-collapse: collapse`, which hides box-shadow applied directly
  // to the row. Layout-neutral (no shift) and reliable across browsers.
  // The accent uses `--bs-link-color`, which Bootstrap re-tints under
  // `[data-bs-theme=dark]`; `--bs-primary` is a fill token and stays fixed, which
  // would leave this line at 2.27:1 against the dark row.
  &[data-drop-target='true'][data-drop-side='before'] td {
    box-shadow: inset 0 3px 0 var(--bs-link-color);
  }

  &[data-drop-target='true'][data-drop-side='after'] td {
    box-shadow: inset 0 -3px 0 var(--bs-link-color);
  }
}
